/* eslint-disable import/no-cycle */
import { persistReducer } from 'redux-persist'
import { combineReducers } from 'redux'
import storageSession from 'redux-persist/es/storage/session'
import localStorage from 'redux-persist/es/storage'
import { reducer as formReducer } from 'redux-form'
import { ThunkAction } from 'redux-thunk'

// reducers
import usersReducer from './users/userReducer'
import authReducer from './authorization/authReducer'
import formDocsReducer from './formDocs/formDocsReducer'
import templatesReducer from './templates/templateReducer'
import formTemplateReducer from './form/formReducer'
import versionReducer from './versions/versionReducer'

export const REDUCER_KEYS = {
	FORMS: 'FORMS',
	FORM_DOCS: 'FORM_DOCS',
	TEMPLATES: 'TEMPLATES',
	USERS: 'USERS',
	LOGIN: 'LOGIN',
	FORM_TEMPLATE: 'FORM_TEMPLATE',
	VERSIONS: 'VERSIONS'
}

const rootReducer = combineReducers({
	auth: persistReducer(
		{
			key: REDUCER_KEYS.LOGIN,
			storage: localStorage
		},
		authReducer
	),
	formDoc: persistReducer(
		{
			key: REDUCER_KEYS.FORM_DOCS,
			storage: storageSession
		},
		formDocsReducer
	),
	template: persistReducer(
		{
			key: REDUCER_KEYS.TEMPLATES,
			storage: storageSession
		},
		templatesReducer
	),
	user: persistReducer(
		{
			key: REDUCER_KEYS.FORM_DOCS,
			storage: storageSession
		},
		usersReducer
	),
	form: persistReducer(
		{
			key: REDUCER_KEYS.FORMS,
			storage: storageSession
		},
		formReducer
	),
	formTemplate: persistReducer(
		{
			key: REDUCER_KEYS.FORM_TEMPLATE,
			storage: storageSession
		},
		formTemplateReducer
	),
	versions: persistReducer(
		{
			key: REDUCER_KEYS.VERSIONS,
			storage: storageSession
		},
		versionReducer
	)
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
export type ThunkResult<R> = ThunkAction<R, RootState, undefined, any>
